<template>
  <div class="stat-wrapper" :class="{active: checked}">
    <div class="stat">{{ name }}</div>
    <div class="func">
      <transition name="fade-stat" mode="out-in">
        <div v-if="settings" class="value" key="valueView">
          <b>{{ value }}</b>
        </div>
        <div v-else class="settings" key="settingsView">
          <input
            type="checkbox"
            v-model="checked"
            :id="id"
          >
          <label :for="id">Toggle</label>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PromotionStat',
  props: ["id", "name", "promotionId", "settings"],
  computed: {
    checked: {
      get() {
        const { promotions } = this.$store.getters;
        const promotion = promotions.find(x => x.id === this.promotionId);
        let stat = null;
        if (promotion !== undefined) { stat = promotion.stats.find(x => x.id === this.id); }
        return stat.active;
      },
      set(value) {
        const payload = {
          id: this.id,
          promotionId: this.promotionId,
          value
        };
        this.$store.commit('checkStat', payload);
      }
    },
    value() {
      const { promotions } = this.$store.getters;
      const promotion = promotions.find(x => x.id === this.promotionId);
      const stat = promotion.stats.find(x => x.id === this.id);
      return stat.value;
    }
  }
};
</script>

<style lang="scss" scoped>
.stat-wrapper {
  color: #707070;
  height: 40px;
  border-top: 1px solid #707070;
  padding: 10px 10px;
  display: flex;
  justify-content: space-between;
  margin: 0;

  .func {
      align-self: flex-end;
    }
    &:first-child {
      border: none;
    }
}

input[type="checkbox"] {
  height: 0;
  width: 0;
  visibility: hidden;

  & + label {
    cursor: pointer;
    text-indent: -9999px;
    width: 36px;
    height: 18px;
    top: 0;
    background: #707070;
    display: block;
    border-radius: 100px;
    position: relative;

    &:after {
    content: "";
    position: absolute;
    top: 2px;
    left: 2px;
    width: 14px;
    height: 14px;
    background: #fff;
    border-radius: 90px;
    transition: 0.3s;
    }

    &:before {
      display: none;
    }
  }
}

input:checked + label {
  background: rgb(45, 186, 221);
}
input:checked + label:after {
  left: calc(100% - 2px);
  transform: translateX(-100%);
}

input + label:after {
  opacity: 1;
  transform: rotate(0);
}

input + label:active:after {
  width: 18px;
}

.active {
  color: #fff;
}

</style>
